/* eslint-disable max-len */
import { bayside } from './bayside';
import { cover_health } from './cover-health';
import { cover_health_specialists } from './cover-health-specialists';
import { demo_clinic } from './demo-clinic';
import { endor } from './endor';
import { endortest } from './endor-test';
import { flamingo_pharmacy } from './flamingo-pharmacy';
import { goodnatal } from './goodnatal';
import { intrepid_health_brampton } from './intrepid-health-brampton';
import { intrepid_health_churchill_meadows } from './intrepid-health-churchill-meadows';
import { intrepid_health_erin_mills } from './intrepid-health-erin-mills';
import { intrepid_health_keswick } from './intrepid-health-keswick';
import { intrepid_health_mississauga } from './intrepid-health-mississauge';
import { intrepid_health_northyork } from './intrepid-health-northyork';
import { intrepid_health_vaughn } from './intrepid-health-vaughn';
import { intrepid_health_welland } from './intrepid-health-welland';
import { intrepid_health_oshawa } from './intrepid-health-oshawa';
import { intrepidhealthsolutions_com } from './intrepidhealthsolutions-com';
import { jackjill_health } from './jackjill-health';
import { kixcare_com } from './kixcare-com';
import { ownhealth_ca } from './ownhealth-ca';
import { veinmd_ca } from './veinmd-ca';
import { momwell_super } from './momwell/momwell_super';
import { momwell } from './momwell/momwell';
import { happyasamother_co } from './momwell/happyasamother_co';
import { momwell_cali } from './momwell/momwell_cali';
import { momwell_digital } from './momwell/momwell_digital';
import { momwell_ca_digital } from './momwell/momwell_ca_digital';
import { momwell_ny } from './momwell/momwell_ny';
import { doc } from './doc';
import { rev } from './revhealth';
import { fifty410 } from './fifty410';
import { trugenics } from './trugenics';
import { gracemd } from './gracemd';
import { intrepid_health_bolton } from './intrepid-health-bolton';
import { directcareai } from './direct-care-ai';
import { OrganizationSettings } from '@care-portals/api-interfaces';

/**
 * All variables must match case type as permission
 * @deprecated to be removed
 */
export const ORGANIZATIONS: { [key: string]: OrganizationSettings } = {
  bayside,
  cover_health_specialists,
  cover_health,
  demo_clinic,
  endor,
  endortest,
  flamingo_pharmacy,
  goodnatal,
  intrepid_health_brampton,
  intrepid_health_churchill_meadows,
  intrepid_health_erin_mills,
  intrepid_health_keswick,
  intrepid_health_mississauga,
  intrepid_health_bolton,
  intrepid_health_northyork,
  intrepid_health_vaughn,
  intrepid_health_welland,
  intrepid_health_oshawa,
  intrepidhealthsolutions_com,
  jackjill_health,
  kixcare_com,
  momwell,
  happyasamother_co,
  momwell_cali,
  momwell_digital,
  momwell_ny,
  momwell_super,
  ownhealth_ca,
  momwell_ca_digital,
  veinmd_ca,
  doc,
  rev,
  fifty410,
  trugenics,
  gracemd,
  directcareai
};

export const getPatientPortalDomain = (
  organizationSettings: OrganizationSettings
) => {
  return (
    organizationSettings.newPatientPortalDomain ||
    organizationSettings.patientPortalDomain
  );
};

export const isLegacyPayment = (organizationSettings: OrganizationSettings) => {
  return !organizationSettings.newPatientPortalDomain;
};